import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// API
import user_API from "components/services/userService";
import {
  setUToken,
  setLocal
} from "components/services/apiService";

class WAP extends Component {
  componentDidMount() {
    const { location, history } = this.props;
    
    // Using URLSearchParams instead of query-string library
    const searchParams = new URLSearchParams(location.search);
    
    const accessToken = searchParams.get('access_token');
    let deviceId = searchParams.get('device_id');
    const redirect = searchParams.get('redirect');
    
    // Clean up deviceId if it contains '/?lan=xxxxxx' at the end
    if (deviceId && deviceId.includes('/?lan=')) {
      deviceId = deviceId.split('/?lan=')[0];
    }
    
    // Save values to localStorage if they exist
    if (accessToken) {
      setUToken(accessToken);
    }
    
    if (deviceId) {
      setLocal("uuid", deviceId);
    }
    
    // Initialize user data and redirect
    this.initializeUserDataAndRedirect(redirect);
  }
  
  initializeUserDataAndRedirect = async (redirectUrl) => {
    const { initUserData, history } = this.props;
    
    try {
      // Get user data similar to firstLogin component
      const userData = await user_API.me(true);
      initUserData(userData);
    } catch (error) {
      console.error('Error initializing user data:', error);
    } finally {
      // Redirect to the specified URL or to home if not provided
      const finalRedirectUrl = redirectUrl || '/';
      history.push(finalRedirectUrl);
    }
  }
  
  render() {
    return <div>Redirecting...</div>;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    initUserData: (payload) => dispatch({ type: "INIT", payload }),
  };
}

export default connect(null, mapDispatchToProps)(withRouter(WAP));